// Languages data details
export const languages = [
  {
    id: 1,
    img: "https://dl.dropboxusercontent.com/scl/fi/uzhd4mw3das6j3c32dm16/icons8-html-logo-96.png?rlkey=mb5w6955q30a6bs7pcad8qka1&dl=0",
    title: "HTML 5",
    percentage: "90%",
  },
  {
    id: 2,
    img: "https://dl.dropboxusercontent.com//scl/fi/08nr9wx1goy5rqxtr56n4/icons8-css-96.png?rlkey=yi5f34qve0eezjaaokjmq1ssg&dl=0",
    title: "CSS 3",
    percentage: "90%",
  },
  {
    id: 3,
    img: "https://dl.dropboxusercontent.com/scl/fi/14rae0v9sco8v8cw2io79/icons8-javascript-96.png?rlkey=8qjsfgk30nf2d43xh53zcn520&dl=0",
    title: "JavaScript",
    percentage: "85%",
  },
  {
    id: 4,
    img: "https://dl.dropboxusercontent.com/scl/fi/hza6onvubgvv7qetom29b/icons8-java-96.png?rlkey=l324jqqymf1fxe3k97hmm5mhx&dl=0",
    title: "Java",
    percentage: "70%",
  },
  {
    id: 5,
    img: "https://dl.dropboxusercontent.com/scl/fi/pw67inz03pocb3l0sibxp/icons8-c-96.png?rlkey=dcnv6ytvj0mllf5v4vvl50pcw&dl=0",
    title: "C++",
    percentage: "65%",
  },
  {
    id: 6,
    img: "https://dl.dropboxusercontent.com/scl/fi/509z0kngyjvq6qhewbr8a/icons8-c-96-1.png?rlkey=kgp6gv6mgtd7dgnthh64zdwls&dl=0",
    title: "C#",
    percentage: "60%",
  },
  {
    id: 7,
    img: "https://dl.dropboxusercontent.com/scl/fi/npsrpblk6vscnhmazpf0x/icons8-php-80.png?rlkey=t8wy9jcr2l8lmwv2oox0kow0h&dl=0%3D0",
    title: "PHP",
    percentage: "80%",
  },
  {
    id: 3,
    img: "https://dl.dropboxusercontent.com/scl/fi/0ymhjt9m29xdrd5r1h1ab/icons8-python-96.png?rlkey=qu5oo06yfaw3by0ku23z9kms4&dl=0",
    title: "Python",
    percentage: "75%",
  },
];

// Framework data details
export const framework = [
  {
    id: 1,
    img: "https://dl.dropboxusercontent.com//scl/fi/runacendnjjnkks2xpn2p/icons8-bootstrap-96.png?rlkey=1bc0i628adti1gibaxts75zq4&dl=0",
    title: "Bootstrap 5",
  },
  {
    id: 2,
    img: "https://dl.dropboxusercontent.com/scl/fi/jnx5btv2q4wwh94084qlp/icons8-tailwind-css-96.png?rlkey=gfgzakvtcse07v7o4wx7prhc2&dl=0",
    title: "Tailwind CSS",
  },
  {
    id: 3,
    img: "https://dl.dropboxusercontent.com/scl/fi/76z5gpb405noeiaw5r3n1/icons8-laravel-is-a-free-open-source-php-web-framework.-96.png?rlkey=0f9p5t3mq5erkrr6qbvg4xqfb&dl=0",
    title: "Laravel",
  },
  {
    id: 4,
    img: "https://dl.dropboxusercontent.com/scl/fi/sj9g7kuly107twti1t4ni/icons8-react-js-100.png?rlkey=15f7k0nsv9rxzavgizwpz3sa0&dl=0",
    title: "React JS",
  },
  {
    id: 5,
    img: "https://dl.dropboxusercontent.com/scl/fi/8u4p3w4qvmunbzs1e0ft9/icons8-vue-js-96.png?rlkey=xml6caa4akip5i4g2pjhe2ffh&dl=0",
    title: "Vue JS",
  },
  {
    id: 6,
    img: "https://dl.dropboxusercontent.com/scl/fi/xinfxbuv1zaeigd7nxnuq/icons8-vite-96.png?rlkey=ck918wlptr3dw5tpk857odhf5&dl=0",
    title: "Vite JS",
  },
];

// Dtabase data details
export const database = [
  {
    id: 1,
    img: "https://dl.dropboxusercontent.com/scl/fi/jn4r0q8u6ulikngcfsk7p/icons8-my-sql-96.png?rlkey=nm3qtxi0n9ipngbdhjl4yw21d&dl=0",
    title: "MySQL",
  },
  {
    id: 2,
    img: "https://dl.dropboxusercontent.com/scl/fi/rzhf03q6btjzmlwyj8fme/icons8-postgresql-100.png?rlkey=ta12199xxa45y41zcgvgp4t0n&dl=0",
    title: "PostgreSQL",
  },
  {
    id: 3,
    img: "https://dl.dropboxusercontent.com/scl/fi/69w4uutfnlmc02ps5unsj/icons8-mongo-db-96.png?rlkey=s5kfutiuaxd90e65uhk86tn6e&dl=0",
    title: "MongoDB",
  },
];

// Projects data details
export const project = [
  {
    id: 1,
    img: "https://dl.dropboxusercontent.com/scl/fi/6cz5eav320cx5zzfdecb6/Screenshot-2023-09-15-204248.png?rlkey=m7gbh40l0vtjnyv8a909yr065&dl=0",
    title: "Cam Travel",
    description:
      "Cam Travel is a website that helps users to share their travel or trip images and locations of that places.",
    link: "https://cam-travel.store/",
  },
  {
    id: 2,
    img: "https://dl.dropboxusercontent.com/scl/fi/p8lcgclduxs98qtvgj12j/Screenshot-2023-09-15-204333.png?rlkey=g6cx04ufer1bcnns6pwa2vpv7&dl=0",
    title: "Cam Library",
    description:
      "Cam Library is a website that helps users to use the Library system online.",
    link: "https://cam-library.vercel.app/",
  },
  {
    id: 3,
    img: "https://dl.dropboxusercontent.com/scl/fi/z378tjxtu8mm0goe6kf5c/Screenshot-2024-03-11-112258.png?rlkey=ev6gfd3ae1wzicoyc1utyj0md&dl=0",
    title: "Country Catalog",
    description:
      "Country Catalog is a website that helps users to know about the countries and their details.",
    link: "https://countries-catalog-kappa.vercel.app/",
  },
  {
    id: 4,
    img: "https://dl.dropboxusercontent.com/scl/fi/g6s7ekojax59b95tgqprr/Untitled-design.jpg?rlkey=3konbdql9laloaz073lz6m7zj&e=1&st=pvm2qyls&dl=0",
    title: "E-attendance Mobile App",
    description:
      "E-Attendance Application (Mobile App): Developed as my project report for the defense of my final year using Express.js for the backend, React JS for web frontend and React Native for the frontend. Features included Attendance Recording, Geolocating with Range Detection(Location filter), Real-Time Tracking, Mobile and QR code Check In/Check Out, and management of Students, Teams, Classes, and Subjects",
    link: "https://github.com/Momsombrathna/E-attendance-Frontend",
  },
  {
    id: 5,
    img: "https://dl.dropboxusercontent.com//scl/fi/x5i9jgq93ofmgh31fywmt/Screenshot-2025-02-24-025042.png?rlkey=vrvdn0fpcrpj83x1u5v0p61wq&e=1&st=g7l7lhrf&dl=0",
    title: "E-attendance Web App",
    description:
      "E-Attendance Application (Web): Features included Admin Dashboard, Attendance Recording, Geolocating with Range Detection(Location filter), Real-Time Tracking, Mobile and QR code Check In/Check Out, and management of Students, Teams, Classes, and Subjects",
    link: "https://e-attendance-web-one.vercel.app/",
  },
  {
    id: 6,
    img: "https://dl.dropboxusercontent.com/scl/fi/dtsaq0y5eykah6uzwnmwg/Screenshot-2025-03-10-120523.png?rlkey=6jajttwkwltjvzdkry3dyttmy&e=1&st=nuipcqox&dl=0",
    title: "E-attendance Report Document",
    description:
      "E-Attendance Application (Report Document): Features included Admin Dashboard, Attendance Recording, Geolocating with Range Detection(Location filter), Real-Time Tracking, Mobile and QR code Check In/Check Out, and management of Students, Teams, Classes, and Subjects",
    link: "https://drive.google.com/file/d/1zSX0jwFGCi6qVnpjz1L9AiV1_YnjeACx/view",
  },
];
